import * as Yup from "yup";
import { VALIDATION_MESSAGES } from ".";

/* Yup validation schema for step3 */
export const getValidationShema = (intl) => {
  const validationShema = Yup.object({
    authorizationImages: Yup.string().required(intl.formatMessage(VALIDATION_MESSAGES.required)),
    authorizationProject: Yup.string().required(intl.formatMessage(VALIDATION_MESSAGES.required)),
    authorizationSupport: Yup.string().when("authorizationProject", {
      is: "Yes",
      then: () => Yup.string()
      .required(intl.formatMessage(VALIDATION_MESSAGES.required)),
      otherwise: () => Yup.string().notRequired(),
    }),
    giveCredits: Yup.string(),
    credits: Yup.string(),
    bussinessUnitPreviewAuthorization: Yup.string(),
  })

  return validationShema;
}
